import './ReliabilityBadge.css';

interface Props {
  score: number | null;
  buildingTrackRecord: boolean;
  /** Compact form for event cards; full form for the detail page lineup. */
  size?: 'sm' | 'md';
}

/**
 * Artist reliability indicator.
 *
 * The engine withholds the score until an artist has 5+ performed events and
 * sends `buildingTrackRecord: true` instead. Showing "no score" as a zero would
 * misrepresent a new artist as a bad one, so that state gets its own neutral
 * treatment rather than a number.
 */
export function ReliabilityBadge({ score, buildingTrackRecord, size = 'sm' }: Props) {
  if (buildingTrackRecord || score == null) {
    return (
      <span className={`reliability reliability--${size} reliability--new`}>
        <span className="reliability__dot" aria-hidden="true" />
        Building track record
      </span>
    );
  }

  const tier = score >= 85 ? 'high' : score >= 65 ? 'mid' : 'low';

  return (
    <span
      className={`reliability reliability--${size} reliability--${tier}`}
      title={`Voleto reliability score: ${score} out of 100`}
    >
      <span className="reliability__dot" aria-hidden="true" />
      <span className="mono reliability__score">{score}</span>
      <span className="reliability__label">reliability</span>
    </span>
  );
}
